export const PROGRESS_TRACKER_STEP_STATUSES = {
  default: 'default',
  active: 'active',
  completed: 'completed',
} as const;
export type ProgressTrackerStepStatus = (typeof PROGRESS_TRACKER_STEP_STATUSES)[keyof typeof PROGRESS_TRACKER_STEP_STATUSES];

export const PROGRESS_TRACKER_STEP_APPEARANCES = {
  default: 'default',
  ticked: 'ticked',
} as const;
export type ProgressTrackerStepAppearance = (typeof PROGRESS_TRACKER_STEP_APPEARANCES)[keyof typeof PROGRESS_TRACKER_STEP_APPEARANCES];
